import type { GroupOverview } from 'shared/hooks/use-load-group-overview';

export type GroupOverviewTenant = GroupOverview['tenants'][number];

export const hasSomethingOpen = ({ subdomain: _subdomain, ...counts }: GroupOverviewTenant) =>
  Object.values(counts).some(count => count > 0);
